const registerSendCode = '/register/send-code';
const register = '/register';
const registerCheckReferral = '/register/check-referral';
const forgetPasswordSendCode = '/forget-password/send-code';
const forgetPasswordReset = '/forget-password/reset';
const login = '/login'
const refresh = '/refresh';
const validateToken = '/validate-token';
const contactStatus ='/contact/status';
const contactGetProfile = '/contact/profile';
const contactUpdateProfile = '/contact/profile';
const contactGetPersonalData = '/contact/personal-data';
const contactUpdatePersonalData='/contact/personal-data';
const contactGroupCreate = '/contact/group/create';
const contactGetGroup = '/contact/group';
const contactJoinGroup = '/contact/group/join';
const contactGetActivity = '/contact/activity';
const contactAddActivity = '/activity';
const contactGetCoins = '/contact/coins';
const ncpInsert = '/ncp/insert';
const gameGetDetails = '/contact/game/details';
const gameGetState = '/contact/game';
const gameSetState = '/contact/game/update';
const gameGetHistory = '/contact/game/all';
const externalCampaign = '/external_campaign/add';
const kozelMeetBoardGame = '/kozel-meet/board-game/add';
const gameKnowYourTribe = '/game-know-your-tribe';
const bicycleGameStore = '/bicycle-game/store';
const bicycleGameUpdate = '/bicycle-game/update';
const bicycleGamePlayer = '/bicycle-game/player';
const bicycleGameTotal = '/bicycle-game/total';
const bicycleGameScore = '/bicycle-game/score';
const bicycleGameGenerateId = '/bicycle-game/generate-id';
const bicycleGameUserDetails = '/bicycle-game/user-details';
const locationCampaign = '/location-campaign/add';
const verifyLocationCampaign = '/location-campaign/verify';
const ncp2026Insert = '/ncp2026/insert';
const kozelBattleGenerateId = '/kozel-battle/generate-id';
const kozelBattleAddScore = '/kozel-battle/add-score';
const kozelBattleTotals = '/kozel-battle/totals';
const kozelBattleUserScores = '/kozel-battle/user';
const kozelBattleUserDetails = '/kozel-battle/user-details';
const kozelBattleTLogin = '/kozel-battle-t/login';
const kozelBattleTGenerateId = '/kozel-battle-t/generate-id';
const kozelBattleTAddScore = '/kozel-battle-t/add-score';
const kozelBattleTUserScores = '/kozel-battle-t/user';
const kozelBattleTBestScores = '/kozel-battle-t/best-scores';


const endpoints = {
    registerSendCode,
    register,
    registerCheckReferral,
    forgetPasswordSendCode,
    forgetPasswordReset,
    login,
    refresh,
    validateToken,
    contactStatus,
    contactGetProfile,
    contactUpdateProfile,
    contactGetPersonalData,
    contactUpdatePersonalData,
    contactGroupCreate,
    contactGetGroup,
    contactJoinGroup,
    contactGetActivity,
    contactAddActivity,
    contactGetCoins,
    ncpInsert,
    gameGetDetails,
    gameGetState,
    gameSetState,
    gameGetHistory,
    externalCampaign,
    kozelMeetBoardGame,
    gameKnowYourTribe,
    bicycleGameStore,
    bicycleGameUpdate,
    bicycleGamePlayer,
    bicycleGameTotal,
    bicycleGameScore,
    bicycleGameGenerateId,
    bicycleGameUserDetails,
    locationCampaign,
    verifyLocationCampaign,
    ncp2026Insert,
    kozelBattleGenerateId,
    kozelBattleAddScore,
    kozelBattleTotals,
    kozelBattleUserScores,
    kozelBattleUserDetails,
    kozelBattleTLogin,
    kozelBattleTGenerateId,
    kozelBattleTAddScore,
    kozelBattleTUserScores,
    kozelBattleTBestScores,
}
export default endpoints;